export const PackageType: Readonly<any> = {
    Regular: 'Regular',
    Adhoc: 'Ad-hoc',
    All: 'All'
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/packageType.ts